module.exports = __webpack_public_path__ + "img/otherTmp.26701a12.png";